(window.InstagramSlider = function (Behaviors) {

  "use strict";
  
  function InstagramSlider(elem) {
    Behaviors.init(InstagramSlider, this, arguments)

    this.instaSlider = this.$elem[0];

    if (window.innerWidth < 768) {
      const instagramSlider = new Swiper(this.instaSlider, {
        wrapperClass: 'instagram__grid',
        slideClass: 'instagram__grid-item',
        speed: 500,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
            loop: false,
          }
        }
      });
    }
  }

  Behaviors.inherit(InstagramSlider, Behaviors.Behavior);
  InstagramSlider.QUERY = '.instagram__images';

  Behaviors.register_behavior(InstagramSlider);
  
  return InstagramSlider;

  }(window.Behaviors));